import styled from 'styled-components';
import { Section as SectionComponent } from '../styles';

export const Section = styled(SectionComponent)`
  max-width: 60rem;
  margin-left: auto;
  margin-right: auto;
`;
